import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

export const errors = {
  notLogin: new Error('未登录或登录已超时，请重新登录')
}

export const authData = JSON.parse(localStorage.getItem('auth') || 'null') || {}
// if (!auth || !auth.token || !auth.user) {
//  // window.gotoLogin()
// }


import goods from './goods'
import cart from './cart'
import flow from './flow'
import order from './order'
import auth from './auth'

export default new Vuex.Store({
  state: {
    user: authData.info || null,
    token: authData.token || ""
  },
  modules: {
    goods,
    cart,
    flow,
    order,
    auth
  }
})
